<!--
  Weekly Site Inspection Form
  
  Step-by-step site inspection with:
  - 3 steps: Basic Information, Hazards, Sign-off
  - Comprehensive site inspection with hazard identification and control methods
  - Dynamic hazard management with add/remove functionality (up to 4 hazards)
  - Form validation for safety compliance and inspection requirements
  - Signature requirements on final step
-->

<!-- Use the form layout component to handle the wizard UI -->
<app-form-layout
  [title]="formTitle"
  [form]="form"
  [icon]="formIcon"
  [disabled]="submitting"
  
  [onSubmit]="onSubmit.bind(this)"
  [steps]="steps"
 [currentStep]="currentStep()"
  [completedSteps]="completedSteps()"
  [canNavigateToStep]="canNavigateToStep.bind(this)"
  [isStepCompleted]="isStepCompleted.bind(this)"
  
  [onNextStep]="onNextStep.bind(this)"
  [onPreviousStep]="onPreviousStep.bind(this)"
  [getProgressPercentage]="getProgressPercentage.bind(this)">

  <div *ngIf="form" formContent [formGroup]="form" class="form-content">
    <!-- Basic Information Step -->
    <div *ngIf="currentStep() === steps[0].id" class="step-content">
    <ion-list>
      <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{steps[0].title}}</h1>
            <p>{{steps[0].description}}</p>
          </ion-label>
        </ion-item-divider>

        <ion-grid>
    
        
          <ion-row>
            <ion-col>
              <app-date-input
                [templateFormGroup]="basicFormGroup"
                [control]="basicFormGroup.get('date')!"
                [label]="fieldMappings['date']"
                [requiredField]="requiredFields['date']"
                [today]="true"
                >
              </app-date-input>
            </ion-col>
          </ion-row>
          
          <ion-row>
            <ion-col>
              <app-text-input
                [templateFormGroup]="basicFormGroup"
                [control]="basicFormGroup.get('jobName')!"
                [label]="fieldMappings['jobName']"
                [requiredField]="requiredFields['jobName']"
                placeholder="Enter job/project name">
              </app-text-input>
            </ion-col>
          </ion-row>
          
          <ion-row>
            <ion-col>
              <app-text-input
                [templateFormGroup]="basicFormGroup"
                [control]="basicFormGroup.get('inspector')!"
                [label]="fieldMappings['inspector']"
                [requiredField]="requiredFields['inspector']"
                placeholder="Enter inspector name">
              </app-text-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
    </div>

    <!-- Hazards Step -->
    <div *ngIf="currentStep() === steps[1].id" class="step-content">
    <ion-list>
      <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{steps[1].title}}</h1>
            <p>{{steps[1].description}}</p>
          </ion-label>
        </ion-item-divider>

        <!-- Hazards and Items to Look For List -->
        <div class="hazards-items-list">
          <h2>Hazards and Items to Look For:</h2>
          <ul>
            <li><b>Housekeeping</b>
              <ul>
                <li>Tripping Hazards</li>
                <li>Passageways And Walkways Clear</li>
                <li>Adequate Lighting</li>
                <li>All Material Is Properly Stacked and Stored.</li>
              </ul>
            </li>
            <li><b>Proper PPE Is Used.</b>
              <ul>
                <li>Hardhats, Safety Glasses, Gloves</li>
              </ul>
            </li>
            <li><b>Check All Equipment (Scissor Lifts, Forklifts, Etc.)</b>
              <ul>
                <li>Daily Inspection</li>
                <li>Workers Trained</li>
              </ul>
            </li>
            <li>Tools Inspected and Have Proper Guarding</li>
            <li>Fire Extinguisher Available and Inspected</li>
            <li>First Aid Kits on Site and Stocked</li>
            <li>Ladders In Safe Condition</li>
            <li><b>Extension Ladders</b>
              <ul>
                <li>Secured At Top</li>
                <li>Extend 3' Past Landing</li>
              </ul>
            </li>
            <li><b>Electrical Cords</b>
              <ul>
                <li>Ground Prongs in Place</li>
                <li>Cut/Worn Insulation.</li>
              </ul>
            </li>
            <li><b>Fall Protection</b>
              <ul>
                <li>Workers Protected from Falls Of 4' Or Higher</li>
                <li>Guardrails Have Top Rail (39-45"), Midrail and Toeboard</li>
                <li>Floor Holes (Over 2") Protected</li>
                <li>Fall Arrest Equipment Inspected</li>
              </ul>
            </li>
          </ul>
        </div>

        <!-- Hazard 1 -->
        <ion-grid>

          <ion-item-divider class="form-subsection-title">
            <ion-label>
              <h2>{{steps[1].sections?.[0]?.title}}</h2>
              <p>{{steps[1].sections?.[0]?.description}}</p>
            </ion-label>
          </ion-item-divider>
         
      
          <ion-row>
            <ion-col class="ion-no-padding-bottom">
              <app-textarea-input
                [templateFormGroup]="hazardsFormGroup"
                [control]="hazardsFormGroup.get('hazardObserved1')!"
                [label]="fieldMappings['hazardObserved1']"
                [requiredField]="requiredFields['hazardObserved1']"
                [rows]="3"
                placeholder="Describe the hazard observed...">
              </app-textarea-input>
            </ion-col>
       
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="hazardsFormGroup"
                [control]="hazardsFormGroup.get('location1')!"
                [label]="fieldMappings['location1']"
                [requiredField]="requiredFields['location1']"
                placeholder="Specify location">
              </app-text-input>
            </ion-col>

            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="hazardsFormGroup"
                [control]="hazardsFormGroup.get('correctiveAction1')!"
                [label]="fieldMappings['correctiveAction1']"
                [requiredField]="requiredFields['correctiveAction1']"
                placeholder="Corrective action taken">
              </app-text-input>
            </ion-col>
          </ion-row>
       
            <app-attachment-upload-section *ngIf="formAttachmentRequirements.uploads"
            [class]="showHazardIndex[1] ? '' : 'ion-no-padding ion-no-margin'"
            [uploadInfo]="formAttachmentRequirements.uploads[0]"></app-attachment-upload-section>
      
        </ion-grid>

        <!-- Hazard 2 -->
        <ng-container *ngIf="showHazardIndex[1]">
  
            <ion-item-divider class="form-subsection-title">
              <ion-label>
                <h2>{{steps[1].sections?.[1]?.title}}</h2>
                <p>{{steps[1].sections?.[1]?.description}}</p>
              </ion-label>
            </ion-item-divider>
        
            <ion-row>
              <ion-col size="12" size-md="4">
                <app-textarea-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('hazardObserved2')!"
                  [label]="fieldMappings['hazardObserved2']"
                  [rows]="3"
                  placeholder="Describe the hazard observed...">
                </app-textarea-input>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" size-md="6">
                <app-text-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('location2')!"
                  [label]="fieldMappings['location2']"
                  placeholder="Specify location">
                </app-text-input>
              </ion-col>
   
              <ion-col size="12" size-md="6">
                <app-text-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('correctiveAction2')!"
                  [label]="fieldMappings['correctiveAction2']"
                  placeholder="Corrective action taken">
                </app-text-input>
              </ion-col>
            </ion-row>
            <ion-row [class]="showHazardIndex[2] ? '' : 'ion-no-padding ion-no-margin'">
            <app-attachment-upload-section *ngIf="formAttachmentRequirements.uploads"
            [uploadInfo]="formAttachmentRequirements.uploads[1]"></app-attachment-upload-section>
          </ion-row>
        </ng-container>

        <!-- Hazard 3 -->
        <ng-container *ngIf="showHazardIndex[2]">
          
            <ion-item-divider class="form-subsection-title">
              <ion-label>
                <h2>{{steps[1].sections?.[2]?.title}}</h2>
                <p>{{steps[1].sections?.[2]?.description}}</p>
              </ion-label>
            </ion-item-divider>
        
            <ion-row>
              <ion-col>
                <app-textarea-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('hazardObserved3')!"
                  [label]="fieldMappings['hazardObserved3']"
                  [rows]="3"
                  placeholder="Describe the hazard observed...">
                </app-textarea-input>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" size-md="6">
                <app-text-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('location3')!"
                  [label]="fieldMappings['location3']"
                  placeholder="Specify location">
                </app-text-input>
              </ion-col>
      
              <ion-col size="12" size-md="6">
                <app-text-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('correctiveAction3')!"
                  [label]="fieldMappings['correctiveAction3']"
                  placeholder="Corrective action taken">
                </app-text-input>
              </ion-col>
            </ion-row>
            <ion-row [class]="showHazardIndex[3] ? '' : 'ion-no-padding ion-no-margin'">
              <app-attachment-upload-section *ngIf="formAttachmentRequirements.uploads"
              [uploadInfo]="formAttachmentRequirements.uploads[2]"></app-attachment-upload-section>
            </ion-row>
          
        </ng-container>

        <!-- Hazard 4 -->
        <ng-container *ngIf="showHazardIndex[3]">
          
            <ion-item-divider class="form-subsection-title">
              <ion-label>
                <h2>{{steps[1].sections?.[3]?.title}}</h2>
                <p>{{steps[1].sections?.[3]?.description}}</p>
              </ion-label>
            </ion-item-divider>
        
            <ion-row>
              <ion-col>
                <app-textarea-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('hazardObserved4')!"
                  [label]="fieldMappings['hazardObserved4']"
                  [rows]="3"
                  placeholder="Describe the hazard observed...">
                </app-textarea-input>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" size-md="6">
                <app-text-input
                  [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('location4')!"
                  [label]="fieldMappings['location4']"
                  placeholder="Specify location">
                </app-text-input>
              </ion-col>
     
              <ion-col size="12" size-md="6">
                <app-text-input
                    [templateFormGroup]="hazardsFormGroup"
                  [control]="hazardsFormGroup.get('correctiveAction4')!"
                  [label]="fieldMappings['correctiveAction4']"
                  placeholder="Corrective action taken">
                </app-text-input>
              </ion-col>
            </ion-row>
            <ion-row class="ion-no-padding ion-no-margin">
          
                <app-attachment-upload-section *ngIf="formAttachmentRequirements.uploads"
                [uploadInfo]="formAttachmentRequirements.uploads[3]"></app-attachment-upload-section>
             
            </ion-row>
          
        </ng-container>

        <!-- Add Hazard Button -->
        <ion-row  class="ion-no-padding ion-no-margin ion-align-items-center">
    
            <ion-button (click)="addHazard()" fill="clear" [disabled]="!showAddHazardButton"
            [title]="showAddHazardButton ? 'Add Hazard' : ''"
            [disabled]="!showAddHazardButton"
            >
              <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-text *ngIf="!showAddHazardButton" class="add-other-button-text">Maximum Reached</ion-text>
        
        </ion-row>
      </ion-list>
    </div>


  </div>
</app-form-layout>